import { render, staticRenderFns } from "./InputMensagem.vue?vue&type=template&id=07079985&scoped=true"
import script from "./InputMensagem.vue?vue&type=script&lang=js"
export * from "./InputMensagem.vue?vue&type=script&lang=js"
import style0 from "./InputMensagem.vue?vue&type=style&index=0&id=07079985&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07079985",
  null
  
)

export default component.exports